<template>
  <v-card
    class="rounded-lg"
    height="calc(100vh - 160px)"
    style="overflow: auto"
  >
    <v-card-text>
      <v-alert rounded="lg" type="info" v-if="!contact">
        Seleccione un cliente para continuar.
      </v-alert>

      <template v-else>
        <template>
          <div class="d-flex flex-row" style="gap: 8px">
            <v-alert
              border="top"
              :outlined="period == 'past'"
              :color="
                period == 'past'
                  ? contact.hasDebts
                    ? 'error'
                    : 'success'
                  : contact.hasDebts
                  ? 'error'
                  : 'success'
              "
              class="rounded-b-0 mb-0"
              width="fit-content"
              @click="period = 'past'"
              style="cursor: pointer; border-bottom: 0 !important; box-sizing: border-box !important; -moz-box-sizing: border-box; -webkit-box-sizing: border-box;"
            >
              <div :class="period == 'past' ? '' : 'white--text'">
                Mes vencido
              </div>
            </v-alert>

            <v-alert
              border="top"
              :color="
                period == 'current_exclusive' ? 'grey lighten-3' : 'primary'
              "
              class="rounded-b-0 mb-0"
              width="fit-content"
              @click="period = 'current_exclusive'"
              style="cursor: pointer"
            >
              <div
                :class="
                  period == 'current_exclusive'
                    ? 'text--primary'
                    : 'white--text'
                "
              >
                Mes en curso
              </div>
            </v-alert>

            <v-alert
              border="top"
              :color="period == 'next' ? 'grey lighten-3' : 'primary'"
              class="rounded-b-0 mb-0"
              width="fit-content"
              @click="period = 'next'"
              style="cursor: pointer"
            >
              <div :class="period == 'next' ? 'text--primary' : 'white--text'">
                Mes entrante
              </div>
            </v-alert>

            <v-alert
              flat
              :color="period == 'receipts' ? 'grey lighten-3' : 'primary'"
              class="rounded-b-0 mb-0 ml-auto"
              width="fit-content"
              @click="period = 'receipts'"
              style="cursor: pointer"
            >
              <div
                :class="period == 'receipts' ? 'text--primary' : 'white--text'"
              >
                Ver recibos
              </div>
            </v-alert>
          </div>

          <v-card
            v-if="period == 'receipts'"
            flat
            color="grey lighten-3 rounded-t-0"
            class="d-flex flex-column"
          >
            <v-card-title class="align-center">
              <div>
                <div class="primary--text font-weight-bold">
                  {{ client.profile.name }}
                </div>

                <div
                  class="body-2 font-weight-medium px-3 py-1 rounded-lg primary white--text"
                  style="width: fit-content"
                >
                  Propietario
                </div>
              </div>

              <v-spacer></v-spacer>

              <div class="text-right">
                <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="receiptDate"
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="receiptDate"
                      label="Filtrar por fecha"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      clearable
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="receiptDate" type="month" scrollable>
                  </v-date-picker>
                </v-dialog>
              </div>
            </v-card-title>

            <v-card flat tile v-if="receipts.length">
              <v-card-text class="px-0">
                <template v-for="receipt in receipts">
                  <card
                    :receipt="receipt"
                    :client="client"
                    clientType="TenantReceipt"
                    class="mt-3"
                  ></card>
                </template>
              </v-card-text>
            </v-card>
          </v-card>

          <v-card
            v-else
            flat
            color="grey lighten-3 rounded-tl-0"
            class="d-flex flex-column"
          >
            <v-card-text class="grow" style="overflow: auto;">
              <div v-if="period == 'next'">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date"
                      label="Mes a pagar"
                      prepend-icon="mdi-calendar"
                      readonly
                      style="max-width: 200px"
                      outlined
                      dense
                      class="rounded-lg"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    type="month"
                    :min="minDate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Cancelar
                    </v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(date)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
              <div class="mb-3 pa-3 white rounded-lg">
                <div class="d-flex align-center">
                  <div class="d-flex flex-row align-center" style="gap: 12px">
                    <div class="primary--text font-weight-bold text-h6">
                      {{ client.profile.name }}
                    </div>

                    <div
                      class="caption font-weight-medium px-2 py-1 rounded-lg primary white--text"
                      style="width: fit-content"
                    >
                      Inquilino
                    </div>
                  </div>

                  <v-spacer></v-spacer>

                  <div
                    class="text-uppercase caption font-weight-medium px-2 py-1 rounded-lg white--text"
                    style="width: fit-content"
                    :class="paid ? 'success' : 'warning'"
                  >
                    Mes {{ paid ? "Pagado" : "Pendiente" }}
                  </div>
                </div>

                <div class="px-3" style="border-left: 1px solid #0000001f">
                  <div
                    class="primary--text mt-3 d-flex align-center"
                    style="gap: 8px"
                  >
                    <div
                      v-if="false"
                      class="rounded-circle"
                      :class="
                        contact.owedMoneyByUs > 0 || contact.owedMoney > 0
                          ? 'error'
                          : 'success'
                      "
                      style="height: 10px; width: 10px; margin-top: -1px"
                    ></div>
                    Estado de cuenta al día de la fecha
                  </div>

                  <div v-if="contact" class="mt-3 d-flex" style="gap: 12px">
                    <v-alert
                      :color="contact.owedMoney < 0 ? 'error' : 'success'"
                      border="left"
                      outlined
                      class="px-3 py-1 rounded-lg white--text font-weight-medium d-flex align-center"
                    >
                      <div class="d-flex align-center" style="gap: 12px">
                        <div>
                          Dinero que le debemos:
                        </div>
                        <div>
                          <div
                            v-for="owed in Object.entries(contact.owedMoney)"
                            v-if="owed[1]"
                          >
                            {{ price(owed[1], owed[0]) }}
                          </div>
                        </div>
                      </div>
                    </v-alert>

                    <v-alert
                      :color="contact.owedMoneyByUs > 0 ? 'error' : 'success'"
                      outlined
                      border="left"
                      class="px-3 py-1 rounded-lg white--text font-weight-medium"
                    >
                      <div class="d-flex align-center" style="gap: 12px">
                        <div>
                          Dinero que nos debe:
                        </div>
                        <div>
                          <div
                            v-for="owed in Object.entries(
                              contact.owedMoneyByUs
                            )"
                            v-if="owed[1]"
                          >
                            {{ price(owed[1], owed[0]) }}
                          </div>
                        </div>
                      </div>
                    </v-alert>
                  </div>
                </div>
              </div>

              <v-row no-gutters class="pr-3 ml-13">
                <v-col cols="5" class="caption">
                  Concepto
                </v-col>

                <v-col cols="2" class="caption text-right">
                  Egreso
                </v-col>

                <v-col cols="2" class="caption text-right">
                  Ingreso
                </v-col>

                <v-col cols="3" class="caption text-right">
                  Fecha asiento
                </v-col>
              </v-row>

              <div class="text-center" v-if="loading">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="100"
                ></v-progress-circular>

                <div class="text-subtitle-1 text--primary mt-3">
                  Cargando datos del cliente
                </div>
              </div>

              <template v-else v-for="(payment, i) in payments">
                <payment
                  :payment="payment"
                  :client="client"
                  :key="band"
                  :expanded="!i"
                  @reload="reload"
                ></payment>
              </template>
            </v-card-text>

            <v-card-actions class="px-4">
              <div class="fill-width text-right text-right text-body-1">
                <div class="py-2 px-3 white rounded-lg">
                  <div>
                    <div
                      class="d-flex justify-end align-center"
                      style="gap: 12px"
                    >
                      <span class="font-weight-bold">Ingreso:</span>
                      <div class="success--text" style="width: 120px">
                        <div
                          v-for="payment in Object.entries(incoming)"
                          v-if="payment[1]"
                        >
                          {{ price(payment[1], payment[0]) }}
                        </div>
                      </div>
                    </div>

                    <div
                      class="mt-2 d-flex justify-end align-center"
                      style="gap: 12px"
                    >
                      <span class="font-weight-bold">Egreso:</span>
                      <div class="error--text" style="width: 120px">
                        <div
                          v-for="payment in Object.entries(outcoming)"
                          v-if="payment[1]"
                        >
                          {{ price(payment[1], payment[0]) }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-2">
                    <div class="d-flex justify-end" style="gap: 12px">
                      <span class="font-weight-bold">
                        Total:
                      </span>

                      <div class="text-right" style="width: 120px">
                        <div
                          v-for="payment in Object.entries(total)"
                          v-if="payment[1]"
                          :class="
                            Math.abs(incoming[payment[0]]) >
                            Math.abs(outcoming[payment[0]])
                              ? 'success--text'
                              : 'error--text'
                          "
                        >
                          {{ price(payment[1], payment[0]) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="false"
                  class="fill-width mt-3 d-flex justify-end"
                  style="gap: 8px"
                >
                  <v-btn depressed class="rounded-lg" color="primary">
                    Pago parcial
                  </v-btn>

                  <v-btn depressed class="rounded-lg" color="primary">
                    Pago total
                  </v-btn>
                </div>
              </div>
            </v-card-actions>
          </v-card>
        </template>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { Receipts } from "@/graphql/queries/receipt";
import { Collections } from "@/graphql/queries/payment";
import { Contact } from "@/graphql/queries/directory";

import Payment from "@/components/payments/tenants/Payment";
import Card from "@/components/payments/Card";

export default {
  data: () => ({
    loading: false,
    menu: false,
    paid: false,
    band: 0,
    period: "current_exclusive",
    total: {
      ARS: 0,
      USD: 0
    },
    partial: {
      ARS: 0,
      USD: 0
    },
    incoming: {
      ARS: 0,
      USD: 0
    },
    outcoming: {
      ARS: 0,
      USD: 0
    },
    date: null,
    minDate: null,
    firstLoad: null,
    contact: null,
    modal: false,
    receiptDate: null,
    receipts: [],
    payments: []
  }),

  props: {
    paymentType: {
      type: String,
      required: true
    },

    client: {
      type: Object,
      required: false
    }
  },

  created() {
    var now = new Date();
    if (now.getMonth() == 11) {
      var current = new Date(now.getFullYear() + 1, 0, 1);
    } else {
      var current = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    }

    this.date = `${current.getFullYear()}-${current.getMonth() + 1}`;
    this.minDate = `${current.getFullYear()}-${current.getMonth() + 1}`;
    this.firstLoad = false;
  },

  watch: {
    date() {
      if (!this.firstLoad) this.fetchPayments();
    },

    client() {
      if (this.client) {
        this.fetchPayments();
        this.fetchContact();
        // this.fetchReceipts ()
      } else {
        this.payments = [];
        this.receipts = [];
      }
    },

    period() {
      if (this.period == "receipts") {
        this.fetchReceipts();
      } else {
        this.fetchPayments();
      }
    }
  },

  methods: {
    fetchReceipts() {
      this.loading = true;

      this.$apollo
        .query({
          query: Receipts,
          variables: {
            id: this.client.id
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.loading = false;
          this.receipts = res.data.receipts;
        });
    },

    fetchPayments() {
      this.total = {
        USD: 0,
        ARS: 0
      };
      this.partial = {
        USD: 0,
        ARS: 0
      };
      this.outcoming = {
        ARS: 0,
        USD: 0
      };
      this.incoming = {
        ARS: 0,
        USD: 0
      };

      let period;
      if (this.period == "next") {
        var months;
        const d1 = new Date();
        const d2 = this.date;

        months = (d2.split("-")[0] - d1.getFullYear()) * 12;
        months -= d1.getMonth();
        months += parseInt(d2.split("-")[1]) - 1;
        period = months.toString();
      } else {
        period = this.period;
      }

      this.$apollo
        .query({
          query: Collections,
          variables: {
            id: this.client.id,
            period: period
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          let result = res.data.collections.pending.reduce(function(r, a) {
            r[a.contractTag] = r[a.contractTag] || [];
            r[a.contractTag].push(a);
            return r;
          }, Object.create(null));

          this.payments = Object.entries(result);

          this.$emit("reload");

          res.data.collections.pending.forEach(payment => {
            this.total[payment.currency] += payment.lastingAmount;

            if (payment.paidAt) {
              this.partial[payment.currency] += payment.lastingAmount;
            }

            if (payment.referralType == "User") {
              this.incoming[payment.currency] += payment.lastingAmount;
            } else {
              this.outcoming[payment.currency] += payment.lastingAmount;
            }
          });

          this.band = this.band + 1;

          const options = { style: "currency", currency: "ARS" };
          const numberFormat = new Intl.NumberFormat("es-AR", options);

          this.paid = !res.data.collections.pending
            .map(payment => payment.state)
            .includes("pending");
        });
    },

    fetchContact() {
      this.$apollo
        .query({
          query: Contact,
          variables: {
            contactId: this.client.id
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.contact = res.data.contact;
        });
    },

    price(amount, currency = "ARS") {
      const options = { style: "currency", currency: currency };
      const numberFormat = new Intl.NumberFormat("es-AR", options);

      return numberFormat.format(Math.abs(amount));
    },

    reload() {
      this.fetchPayments();
      this.fetchReceipts();
    }
  },

  components: {
    Payment,
    Card
  }
};
</script>
